import React from 'react';
import axios from 'axios';
import jwt_decode from "jwt-decode";

// Material UI Imports
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';

//Route Imports
import { Link } from 'react-router-dom';

// Assets imports
import '../styles/Login.css';
import logo from '../assets/lexia_logo_960x160.jpg';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: process.env.REACT_APP_PRIMARY_COLOR,
    },
  },
  typography: {
    useNextVariants: true,
  },
});

const paperStyle = {
  // Css to center the paper
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // General styles for paper
  width: "30%",
  height: "auto",
  padding: "2em",
  textAlign: 'center',
};

const buttonStyle = {
  login: {
    marginTop: 20,
  },
  identify: {
    float: "Right",
    label: {
      padding: 0,
      fontWeight: 400,
      textTransform: "capitalize"
    },
  }
};

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      identifier: 'react-frontend-dev',
      type: 'Web'
    }
  }

  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    const ssoToken = params.get('sso_token')

    if (ssoToken) {
      const decodedSsoToken = jwt_decode(ssoToken);
      localStorage.setItem("token", ssoToken);
      localStorage.setItem("current_user", decodedSsoToken.sub.user_device);
      localStorage.setItem("current_user_role", decodedSsoToken.sub.role);
      localStorage.setItem("current_user_name", decodedSsoToken.sub.user_name);
      this.props.history.push("./app");
    }
  }

  handleClick(event) {
    var apiBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL + "/api/signin";
    // var apiBaseUrl ='http://52.67.237.101/api/signin';

    // check another name for this
    var temp = this;

    axios.post(apiBaseUrl, {
      user: {
        email: this.state.email,
        password: this.state.password,
        identifier: this.state.identifier,
        type: this.state.type
      }
    }).then(function (response) {
      if (response.data.status === "ok") {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("current_user", response.data.user_id);
        localStorage.setItem("current_user_role", response.data.role);
        localStorage.setItem("current_user_name", response.data.user_name);
        temp.props.history.push("./app");
        // temp.context.router.history.push("./app");

      }
      else {
        alert(response.data.message)
      }
    }).catch(function (error) {
      alert(error)
      console.log(error);
    });
  }


  render() {
    return (
      <div className="Login">
        <MuiThemeProvider theme={theme}>
          <Paper style={paperStyle} elevation={3}>
            <img src={logo} className="Login-logo" alt="logo" />
            <h1 className="Login-title">Rhodar Site Packs by Claritas Solutions</h1>
            <p>Log in to your Lexia administration portal</p>
            <div>
              <div style={{marginTop: 30, width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <a href={process.env.REACT_APP_BACKEND_SSO_URL}>
                  <Button
                    variant="contained"
                    color="primary"
                    style={buttonStyle.login}
                  >Login with your Microsoft Account</Button>
                </a>
              </div>
              <div style={{marginTop: 30, width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <Button
                  color="primary"
                  style={buttonStyle.identify}
                  component={Link}
                  to="/emailLogin"
                >Login with  previous email/password</Button>
              </div>
            </div>
          </Paper>
        </MuiThemeProvider>
      </div>
    )
  }
}

export default Login;



// WEBPACK FOOTER //
// src/components/Login.js